import React from 'react';

import { Checkbox, Toggle, Wrapper } from './wrapper';

type SwitchProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  id: string;
  label?: string;
};

const Switch = ({ label, ...props }: SwitchProps) => {
  const { id } = props;

  return (
    <Wrapper aria-label={label}>
      <Checkbox
        {...(props as React.DetailedHTMLProps<
          React.InputHTMLAttributes<HTMLInputElement>,
          HTMLInputElement
        >)}
      />
      <Toggle htmlFor={id} />
    </Wrapper>
  );
};

export default Switch;
